export const environment = {
  production: false,
  distributionAddress: '0xC05b605356695794faAbF0dd5d123Ccd2b960aFa', // Replace with actual deployed TeamTokenDistribution contract address
  tokenDecimals: 18,
  chainId: 84532, // Base Sepolia testnet
  chainName: 'Base Sepolia',
  rpcUrl: 'https://sepolia.base.org',
  // Reown AppKit Project ID - get your own from https://cloud.reown.com
  projectId: 'dfb0bbadae976a58500005b16271ebaa'
};
